import { Box, Flex, Text } from '@chakra-ui/react';
import { BackofficeActivitiesOrderItem } from '@diamond/shared/types';
import { LabelPromo } from '@diamond/shared/ui';

import { ColumnComponentProps } from '../../../types/activity-column-types';
import { CheckIconVoucher } from './Icons';

type Props = ColumnComponentProps<BackofficeActivitiesOrderItem, string>;

type VoucherRuleProductLike = {
  is_rule_product?: boolean;
  rules?: Array<{ reward_type?: string | null }>;
};

export function ProductNameColumn({ info }: Props) {
  const item = info.row.original as BackofficeActivitiesOrderItem & {
    has_voucher_discount?: boolean;
    voucher_code?: string;
    voucher_rule_product?: VoucherRuleProductLike;
  };

  const hasVoucherDiscount = item.has_voucher_discount ?? false;
  const voucherCode = item.voucher_code;
  const voucherRuleProduct = item.voucher_rule_product;

  const isVoucherRuleProduct = voucherRuleProduct?.is_rule_product ?? false;
  const hasVoucherContext = Boolean(
    isVoucherRuleProduct || hasVoucherDiscount || voucherCode
  );

  const hasVoucherFreeGoodsRule = Boolean(
    voucherRuleProduct?.rules?.some((rule) =>
      ['FREE_GOODS', 'FREE_GOODS_BUNDLING'].includes(
        String(rule?.reward_type ?? '')
      )
    )
  );

  return (
    <Box>
      <Text mb="1" fontSize="sm" fontWeight="400" color="#373F41">
        {info.getValue()}
      </Text>
      <Flex gap="2" alignItems="center" flexWrap="wrap">
        {info.row.original.is_discount === true && (
          <LabelPromo type="discount" />
        )}
        {info.row.original.quantity_free_goods && !hasVoucherContext && (
          <LabelPromo type="free-item" />
        )}

        {hasVoucherContext && (
          <CheckIconVoucher boxSize="20px" data-testid="voucher-icon" />
        )}

        {hasVoucherDiscount && <LabelPromo type="discount" />}
        {isVoucherRuleProduct &&
          hasVoucherFreeGoodsRule &&
          !hasVoucherDiscount && (
            <Text
              fontSize="sm"
              fontWeight="400"
              color="red.500"
              fontStyle="italic"
            >
              *Syarat produk gratis
            </Text>
          )}
      </Flex>
    </Box>
  );
}
